import { createActionGroup, emptyProps, props } from "@ngrx/store";
import {StationGnvList} from '../../../swagger-gen/gnvert-secured/models/station-gnv-list';
import {SearchStationsCustom$Params} from '../../../swagger-gen/gnvert-secured/fn/station/search-stations-custom';

export const StationsActions = createActionGroup({
  source: "Stations",
  events: {
    Search: props<{filter: SearchStationsCustom$Params}>(),
    "loader Start": emptyProps(),
    "Fetch Success": props<{ response: StationGnvList}>(),
    "Fetch Failure": props<{ message: string }>(),
    Clean: emptyProps(),
  },
});

